import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class successDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open:false
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.open !== this.state.open){
            this.setState({
                open: nextProps.open
            })
        }
    }

    handleClose = () => {
        this.setState({ open: false });
        if(this.props.closeFunction) this.props.closeFunction();
    };
    handleOK = () =>{
        this.setState({ open: false });
        if(this.props.okFunction) this.props.okFunction();
    };

    render() {
        const {errorCount} = this.props;
        return (
            <Dialog
                open={this.state.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">
                    解析終了
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <span style={{fontWeight:'bold',color:"#000000"}}>合計{errorCount}ページ</span>のQRコードの解析に失敗しました。<br />
                        手動登録画面へ進みます。<br />
                        <span style={{display:'inline-block', fontSize:'80%', marginTop:20, color:'#f44336'}}>
                            ※「処理中のファイルを破棄する」をクリックすると<br />
                            アップロード処理中のファイルはすべて破棄されます
                        </span>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        処理中のファイルを破棄する
                    </Button>
                    <Button onClick={this.handleOK} color="primary">
                        手動入力へ進む
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
successDialog.propTypes = {
    open:PropTypes.bool,
    errorCount:PropTypes.number,
    okFunction:PropTypes.func,
    closeFunction:PropTypes.func

};
successDialog.defaultProps = {
    open:false
};
export default successDialog;


// WEBPACK FOOTER //
// ./src/routes/upload-receipt/components/success-dialog.js